<template>
    <div class="body">
            <p  class="font1" style="padding-top: 8vh;">Hi~ <a class="font3">{{ ReportData.stuname }}</a>，我们又见面啦</p>
            <p  class="font1">一起回顾<a class="font3">2023</a>年的成长点滴吧</p>

            <p class="font1" style="padding-top: 1vh;">2023年即将过去</p>
            <p class="font1">感谢你</p>
            <p class="font1">与富士康科技集团携手走过<a class="font3">{{ ReportData.hyear }}</a>年~</p>

            <p class="font1">这一年</p>
            <p class="font1">你在富学宝典平台上的学习天数达到了<a class="font3">{{ ReportData.studate }}</a>天</p>
        <!-- <p class="font2" style="padding-top: 5vh;">赶快来开启专属你的年度学习报告吧~</p> -->
    </div>
</template>
  
<script>

export default {
      props: [ "ReportData"],
      data() {
        return {   
        }
      },
      created() {
        
      }
}
</script>
  
<style scoped>
.body {
    background:url("../../assets/year23/bg1.jpg")  no-repeat;
    background-size: 100% 100%,cover;
    width: 100%;
    height: 100vh;
}

.font1 {
    width: 92%;
    margin: 0;
    text-align: right;
    font-size: 17px;
    color: #fff;

    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font2 { 
    width: 80%;
    color: #000;
    font-size: 15px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font3 {
    font-size: 25px;
    color: #953b5d;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-weight: bolder;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
</style>